import { Tooltip } from "@mui/material"
import { DigitalSignageStatusCode } from "../../menuPlanningTypes"
import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"
import { StandardChip } from "../../../../../../shared/components/badges/StandardChip"

export function SignsStatusChip({ status }: { status?: DigitalSignageStatusCode }) {
    const { l10n } = useAppLocalization()

    if (!status) {
        return null
    }

    switch (status) {
        case DigitalSignageStatusCode.OKAY:
            return (
                <StandardChip
                    variant="success"
                    label={l10n.getStringForEnum(
                        "merchant-menu-planning-digital-signage-card-status-code",
                        status.toString(),
                        "Ok",
                    )}
                />
            )
        // TODO: Add more cases here or remove
        case DigitalSignageStatusCode.LOW_BATTERY:
        case DigitalSignageStatusCode.LOW_TEMPERATURE:
            return (
                <Tooltip
                    arrow
                    title={l10n.getStringForEnum(
                        "merchant-menu-planning-digital-signage-card-status-code",
                        status,
                        "Warning",
                    )}
                >
                    <StandardChip
                        variant="yellow"
                        label={l10n.getStringForEnum(
                            "merchant-menu-planning-digital-signage-card-status-code",
                            status,
                            "Warning",
                        )}
                    />
                </Tooltip>
            )
        default:
            return (
                <Tooltip
                    arrow
                    title={l10n.getStringForEnum(
                        "merchant-menu-planning-digital-signage-card-status-code",
                        status,
                        "Error",
                    )}
                >
                    <StandardChip
                        variant="red"
                        label={l10n.getStringForEnum(
                            "merchant-menu-planning-digital-signage-card-status-code",
                            status,
                            "Error",
                        )}
                    />
                </Tooltip>
            )
    }
}
